import Alphatar from './Alphatar';

export default Alphatar;
